import { jsx as C } from "react/jsx-runtime";
import o from "../svg-icon/svg-icon.component.js";
function t(e) {
  return /* @__PURE__ */ C(o, { width: "24", height: "24", viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ C(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.38 20.42C1.88 21.28 2.77001 21.79 3.76001 21.79H20.24H20.26C21.25 21.79 22.14 21.28 22.64 20.42C23.13 19.57 23.13 18.54 22.64 17.68L14.4 3.25999C13.9 2.38999 13.01 1.87 12.01 1.87C11.01 1.87 10.12 2.38999 9.62 3.25999L1.38 17.68C0.880005 18.54 0.880005 19.56 1.38 20.42ZM10.92 4C11.1392 3.61143 11.547 3.37176 11.995 3.37C12.4529 3.37176 12.8508 3.61143 13.08 4L21.32 18.42C21.55 18.81 21.55 19.28 21.32 19.67C21.09 20.06 20.69 20.29 20.24 20.29H3.76001C3.31001 20.29 2.90999 20.06 2.67999 19.67C2.45999 19.28 2.45999 18.81 2.67999 18.42L10.92 4ZM12.75 13.88V8.63H11.25V13.88H12.75ZM12 17.38C11.45 17.38 11 16.93 11 16.38C11 16.12 11.1 15.87 11.29 15.67C11.48 15.47 11.73 15.38 12 15.38C12.55 15.38 13 15.83 13 16.38C13 16.93 12.55 17.38 12 17.38Z"
    }
  ) });
}
export {
  t as AlertIcon
};
//# sourceMappingURL=alert.js.map
